// extracted by mini-css-extract-plugin
module.exports = {"error":"NotFound_error__3w1aE","img":"NotFound_img__oymlM","content":"NotFound_content__1UgMA"};